import type {BatchRpcRequest, RpcRequest} from './types';

export function isBatchRequest(
  maybeBatch: BatchRpcRequest | RpcRequest,
): maybeBatch is BatchRpcRequest {
  return Boolean((maybeBatch as BatchRpcRequest).batch);
}
